var _style, _g, _path, _g2, _script;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoonwell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 253.4 70.2",
    style: {
      enableBackground: "new 0 0 253.4 70.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFF1B2;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:#5076FF;}\r\n\t.st3{fill:#B80083;}\r\n\t.st4{fill:#5032FF;}\r\n\t.st5{fill:#CC00D5;}\r\n\t.st6{fill:#7800FF;}\r\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.9,28l2.5,8.2L9.9,28l0.1,0h1.5v22H10V33.4l-1.9,6.2H6.7l-2-6.4V50H3.1V28h1.6L4.9,28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.6,27.9h1.5c1.2,0,2.2,0.5,2.9,1.6c0.4,0.6,0.6,1.3,0.6,2v15c0,1.2-0.5,2.2-1.5,2.9    c-0.6,0.4-1.2,0.6-1.9,0.6h-1.5c-1.2,0-2.2-0.5-2.9-1.6c-0.4-0.6-0.6-1.3-0.6-2v-15c0-1.2,0.5-2.2,1.5-2.9    C29.3,28.2,29.9,28,30.6,27.9z M30.6,29.6c-0.8,0-1.4,0.4-1.7,1.1c-0.1,0.3-0.2,0.5-0.2,0.8v15c0,0.8,0.4,1.3,1.1,1.6    c0.3,0.1,0.5,0.2,0.8,0.2h1.5c0.8,0,1.4-0.4,1.7-1.1c0.1-0.3,0.2-0.5,0.2-0.8v-15c0-0.8-0.4-1.3-1.1-1.6c-0.3-0.1-0.5-0.2-0.8-0.2    H30.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.5,27.9H56c1.2,0,2.2,0.5,2.9,1.6c0.4,0.6,0.6,1.3,0.6,2v15c0,1.2-0.5,2.2-1.5,2.9    C57.3,49.8,56.7,50,56,50h-1.5c-1.2,0-2.2-0.5-2.9-1.6c-0.4-0.6-0.6-1.3-0.6-2v-15c0-1.2,0.5-2.2,1.5-2.9    C53.2,28.2,53.9,28,54.5,27.9z M54.5,29.6c-0.8,0-1.4,0.4-1.7,1.1c-0.1,0.3-0.2,0.5-0.2,0.8v15c0,0.8,0.4,1.3,1.1,1.6    c0.3,0.1,0.5,0.2,0.8,0.2H56c0.8,0,1.4-0.4,1.7-1.1c0.1-0.3,0.2-0.5,0.2-0.8v-15c0-0.8-0.4-1.3-1.1-1.6c-0.3-0.1-0.5-0.2-0.8-0.2    H54.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75,28h1.6l5.2,16.6V28h1.6v22h-1.6l-5.2-16.6v16.6H75V28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.6,28l0.7,15.5l1.2-5.5h1.5l1.2,5.5l0.7-15.5h1.6l-1,22h-1.6l-1.6-7.9l-1.6,7.9H170l-1-22H170.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M193,27.9h1.6h6.9v1.7h-6.9v8.4h4v1.7h-4v8.4h6.9v1.7h-6.9H193v-1.7V29.6V27.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217.1,28h1.6v20.3h6.9v1.7h-6.9h-0.4h-1.2V28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.1,28h1.6v20.3h6.9v1.7h-6.9h-0.4h-1.2V28z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 1043.5573,
    cy: -213.151,
    r: 31.5612,
    gradientTransform: "matrix(0.979 -0.204 0.204 0.979 -851.8917 457.6764)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8364,
    style: {
      stopColor: "#FFF1B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9774,
    style: {
      stopColor: "#FFCF60"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.6,55.8c14,6.9,30.9,1.2,37.8-12.8c6.9-14,1.2-30.9-12.8-37.8c-1.2-0.6-2.5-1.1-3.8-1.5     c3.5,0.4,7,1.4,10.4,3.1c15.8,7.8,22.3,27,14.5,42.8c-7.8,15.8-27,22.3-42.8,14.5c-10-4.9-16.2-14.4-17.5-24.6     C96.7,46.3,101.6,52.3,108.6,55.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M146.3,33.5c-1.6,0-4,0.2-6.8,0.9c-0.1,0-0.2,0.1-0.4,0.1c-0.1,0-0.2,0.1-0.4,0.1c-1.4,0.4-2.7,0.9-3.9,1.6     c-1.2,0.6-2.3,1.3-3.3,2c-0.1,0.1-0.2,0.2-0.4,0.3c-0.1,0.1-0.3,0.2-0.4,0.3c-3.2,2.7-5.7,6.3-7.2,10.9c-0.2,0.6-0.4,1.2-0.6,1.9     c-0.4,1.5-0.7,3-0.9,4.6c0,0,0.1,0,0.1,0c6.2-0.2,12.1-2.7,16.7-6.9c4.5-4.2,7.3-9.7,8.1-15.8C146.8,33.5,146.5,33.5,146.3,33.5z     "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M119,49.6c-1.5-4.5-3.9-8.2-7.2-10.9c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.3-0.2-0.4-0.3     c-1-0.8-2.1-1.4-3.3-2c-1.2-0.6-2.5-1.1-3.9-1.6c-0.1,0-0.2-0.1-0.4-0.1c-0.1,0-0.2-0.1-0.4-0.1c-2.8-0.7-5.2-0.9-6.8-0.9     c-0.3,0-0.5,0-0.8,0c0.8,6.1,3.7,11.7,8.2,15.9c4.6,4.2,10.5,6.6,16.7,6.8c-0.2-1.6-0.5-3.2-0.9-4.6     C119.3,50.9,119.2,50.3,119,49.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M125.7,42.8c1.4-2.1,3-3.9,4.9-5.4c0.1-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.2-0.2,0.4-0.3c0.9-0.7,1.9-1.3,3-1.8     c1.3-0.7,2.7-1.2,4.2-1.7c0.5-6.4-0.9-11.8-1.5-13.6c-1.1,0.5-4.2,2.1-7.4,4.9c-0.1,0.1-0.2,0.2-0.3,0.2     c-0.1,0.1-0.2,0.2-0.3,0.3c-1,0.9-1.9,1.9-2.8,2.9c-1.9,2.3-3.5,4.9-4.5,7.6c-0.1,0.2-0.1,0.3-0.2,0.5c-0.1,0.2-0.1,0.4-0.2,0.6     c-1.3,3.9-1.8,8.2-1.4,12.8c0.5,1.5,0.9,3.1,1.2,4.8c0.3-1.7,0.7-3.3,1.2-4.8c0.1-0.4,0.3-0.9,0.5-1.3c0.1-0.3,0.3-0.7,0.4-1     C124,45.6,124.8,44.2,125.7,42.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M108.2,35.1c1,0.5,2,1.1,3,1.8c0.1,0.1,0.2,0.2,0.4,0.3c0.2,0.1,0.3,0.2,0.4,0.3c1.9,1.5,3.6,3.3,4.9,5.4     c0.7,1.1,1.3,2.2,1.9,3.4c0-2.3,0.2-4.5,0.7-6.6c0.3-1.4,0.7-2.8,1.2-4.1c-1.1-2.7-2.6-5.3-4.5-7.6c-0.8-1-1.8-2-2.8-2.9     c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.2-0.2-0.3-0.2c-3.2-2.8-6.2-4.3-7.4-4.9c-0.5,1.8-1.9,7.3-1.5,13.6     C105.5,33.9,106.9,34.5,108.2,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M117,27.3c1.8,2.1,3.2,4.4,4.3,6.8c1.1-2.4,2.5-4.7,4.3-6.8c0.9-1.1,1.9-2.1,2.9-3     c-2.4-6.1-5.9-10.4-7.2-11.8c-1.3,1.4-4.9,5.7-7.2,11.8C115.1,25.2,116.1,26.2,117,27.3z"
  }))))), _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: "",
    type: "application/javascript"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonwell);
export default __webpack_public_path__ + "static/media/moonwell.267c7b4f29937bc491fc7dd3935f1c0b.svg";
export { ForwardRef as ReactComponent };